/* This file is written by gulp task constants */
export default {
	"CHROME_EXTENSION_LINK": "https://static.bam-x.com/chrome_extension/release/extension.zip",
	"AUTH_VERSION": "1.1",
	"SHOW_RESET_DB": false,
	"API_BASE_URL": "/api/v0/",
	"API_V1_URL": "/api/v1/",
	"ADMIN_API_ENDPOINT": "admins/",
	"PUBLISHER_API_ENDPOINT": "publishers/",
	"MERCHANT_API_ENDPOINT": "merchants/",
	"PRODUCT_MATCH_API_ENDPOINT": "product_match/",
	"CLIENT_ID": "1636934586.apps.bam-x.com",
	"CLIENT_SECRET": "fvux6k12jk094c8g4m1q69jbdf0f0pvu",
	"HOST_PACT": "http://localhost:4445",
	"ENV": "release",
	"HOST": "//api.bam-x.com",
	"ELASTICSEARCH": "api.bam-x.com/api/v0/product/search",
	"STATIC_BAM_BOX_ENDPOINT": "//static.bam-x.com/bam_box/",
	"ENABLE_ALL_BAM_BOX_TAG_TYPES": false,
	"BAMX_BUILD_VERSION": "7b535afb70952c678f4d41c021675c9ba372be05"
};
